export default __webpack_public_path__ + "static/media/dis-im.cb66a303.png";